export class LicenseService {
	
	
	//@ngInject
	constructor( 
		private $q, 
		private publicService, 
		private apiService 
	) {
		
	}
	
	public canSelfAssign = (formData) =>{
		let deferred = this.$q.defer();
		
		this.apiService.request( 'davisdigital:api.selfAssignBook', {} ).then( result => {
			deferred.resolve( result.status === 200 );
		}).catch( result => {
			deferred.reject( result.status === 200 );
		});
		
		return deferred.promise;
	}
	
	public selfAssignBooks = (formData) =>{
		let deferred = this.$q.defer();
		
		this.apiService.request( 'davisdigital:api.selfAssignBook', formData ).then( result => {
			deferred.resolve( result.data );
		}).catch( result => {
			deferred.reject( result );
		});
		
		return deferred.promise;
	}
	
	public hasPendingLicenseAssignment = () =>{
		let deferred = this.$q.defer();
		
		this.apiService.request( 'davisdigital:api.hasPendingLicenseAssignment', {} ).then( result => {
			deferred.resolve( result.data );
		}).catch( result => { 
			deferred.reject( result );
		});
		
		return deferred.promise;
	}
}